import { cn } from '../../utils/cn'
import { Image } from '../Image'

export type AvatarProps = {
  className?: string
  username: string
  src?: React.ComponentProps<typeof Image>['src']
  gender?: 'none' | 'men' | 'women'
  isEditable?: boolean
  onClick?: () => void
}

export const Avatar = ({
  className,
  username,
  src,
  gender,
  isEditable,
  onClick,
}: AvatarProps) => {
  const fallbackSrc =
    gender === 'men'
      ? '/assets/images/user/usericon_men.png'
      : gender === 'women'
      ? '/assets/images/user/usericon_women.png'
      : '/assets/images/user/usericon_none.png'

  return (
    <div
      className={cn(
        'group relative inline-flex size-[100px] shrink-0 items-center justify-center overflow-hidden rounded-full',
        className,
      )}
      onClick={onClick}
    >
      <div className="relative flex size-[100px] items-center justify-center">
        <Image
          className="object-cover"
          src={src ?? fallbackSrc}
          alt={username}
          fill
          sizes="100px"
        />
      </div>

      {isEditable && (
        <div className="absolute inset-0 flex cursor-pointer items-center justify-center bg-[rgba(0,0,0,0.5)] opacity-100 transition-opacity group-hover:opacity-100 pc:opacity-0">
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10 0V8H18V10H9.999L10 18H8L7.999 10H0V8H8V0H10Z"
              fill="white"
            />
          </svg>
        </div>
      )}
    </div>
  )
}
